import { Box, Card, CardContent, Divider, Grid, Stack, Typography } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { useState } from 'react';
import PermissionButton from 'src/components/permission/PermissionButton';
import { PermissionPath } from 'src/components/permission/PermissionPath';
import { snackActions } from 'src/components/notistack/SnackbarUtilsConfigurator';
import axiosInstance from 'src/utils/axios';

const REPORTS = [
  {
    title: 'واحدهای با بیشترین کنسلی',
    description: 'لیست واحدهایی که بیشترین سفارشات کنسل‌شده را دارند',
    url: 'reports/high-cancellation-shops',
    filename: 'واحدهای با بیشترین کنسلی.xlsx',
    permission: PermissionPath.Reports.reportHighCancellationShops,
  },
  {
    title: 'واحدهای بدون محصول قابل نمایش',
    description: 'لیست واحدهایی که هیچ محصول فعالی برای نمایش ندارند',
    url: 'reports/shops-without-visible-products',
    filename: 'واحدهای بدون محصول.xlsx',
    permission: PermissionPath.Reports.reportShopsWithoutVisibleProducts,
  },
];

const ReportManagement = () => {
  const [loadingMap, setLoadingMap] = useState({});

  const handleDownload = async (url, filename) => {
    try {
      setLoadingMap((prev) => ({ ...prev, [url]: true }));
      const response = await axiosInstance.get(url, { responseType: 'blob' });
      const blob = new Blob([response.data]);
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      snackActions.success('فایل درخواستی دانلود شد');
    } catch {
      snackActions.error('خطا در دانلود فایل');
    } finally {
      setLoadingMap((prev) => ({ ...prev, [url]: false }));
    }
  };

  return (
    <Grid item xs={12} md={10} lg={8}>
      <Card>

        <CardContent sx={{ p: 2 }}>
          <Stack spacing={1.5}>
            {REPORTS.map((report) => (
              <Box
                key={report.url}
                sx={{
                  display: 'flex',
                  alignItems: { xs: 'flex-start', sm: 'center' },
                  justifyContent: 'space-between',
                  flexDirection: { xs: 'column', sm: 'row' },
                  gap: { xs: 1.5, sm: 0 },
                  px: 2.5,
                  py: 2,
                  borderRadius: 1.5,
                  border: '1px solid',
                  borderColor: 'divider',
                  transition: 'background-color 0.15s',
                  '&:hover': { bgcolor: 'action.hover' },
                }}
              >
                <Box>
                  <Typography variant="subtitle1" fontWeight={600}>
                    {report.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" mt={0.3}>
                    {report.description}
                  </Typography>
                </Box>

                <PermissionButton
                  title="دانلود اکسل"
                  size="medium"
                  variant="outlined"
                  startIcon={<FileDownloadOutlinedIcon />}
                  onClick={() => handleDownload(report.url, report.filename)}
                  loading={!!loadingMap[report.url]}
                  permission={report.permission}
                  sx={{
                    minWidth: { xs: '100%', sm: 130 },
                    flexShrink: 0,
                  }}
                />
              </Box>
            ))}
          </Stack>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default ReportManagement;
